import { createAsyncThunk } from "@reduxjs/toolkit";

import { getData, postData } from "../../../../services";

export const aadharOtpThunk = createAsyncThunk(
  "/otp",
  async (aadharRequest, { rejectWithValue }) => {
    try {
      console.log("req", aadharRequest);
      const result = await postData(`/enrollment/request/otp`, {
        ...aadharRequest,
      });
      return result.data;
    } catch (err) {
      return rejectWithValue({ error: err?.response?.data });
    }
  }
);

export const enrollByAadharThunk = createAsyncThunk(
  "/verifyOtp",
  async (verifyOtpRequest, { rejectWithValue }) => {
    try {
      const result = await postData(`/enrollment/enrol/byAadhaar`, {
        ...verifyOtpRequest,
      });
      return result.data;
    } catch (err) {
      return rejectWithValue({ error: err?.response?.data });
    }
  }
);

export const resendOtpAadharThunk = createAsyncThunk(
  "/resendOtp",
  async (resendOtpRequest, { rejectWithValue }) => {
    try {
      const result = await postData(`/enrollment/request/otp`, {
        ...resendOtpRequest,
      });
      return result.data;
    } catch (err) {
      return rejectWithValue({ error: err?.response?.data });
    }
  }
);

export const suggestionAadharThunk = createAsyncThunk(
  "/suggestion",
  async (request, { rejectWithValue }) => {
    try {
      console.log(request, "request");

      const result = await getData(`/enrollment/enrol/suggestion`, request);
      return result.data;
    } catch (err) {
      return rejectWithValue({ error: err?.response?.data });
    }
  }
);

export const createAbhaAddressThunk = createAsyncThunk(
  "/abhaAddress",
  async (abhaRequest, { rejectWithValue }) => {
    try {
      const result = await postData(`/enrollment/enrol/abha-address`, {
        ...abhaRequest,
      });
      return result.data;
    } catch (err) {
      return rejectWithValue({ error: err?.response?.data });
    }
  }
);

export const mobileVerifyOtpRequestThunk = createAsyncThunk(
  "/mobileVerifyOtpRequest",
  async (request, { rejectWithValue }) => {
    try {
      const result = await postData(`/enrollment/request/otp`, {
        ...request,
      });
      return result.data;
    } catch (err) {
      return rejectWithValue({ error: err?.response?.data });
    }
  }
);

export const mobileVerifyOtpThunk = createAsyncThunk(
  "/mobileVerifyOtp",
  async (request, { rejectWithValue }) => {
    try {
      const result = await postData(`/enrollment/auth/byAbdm`, {
        ...request,
      });
      return result.data;
    } catch (err) {
      return rejectWithValue({ error: err?.response?.data });
    }
  }
);
